// if (!window.location.href.includes("collections")) {
// setInterval(() => {
//   $.ajax({
//     type: 'GET',
//     url: '/cart.js',
//     dataType: 'json',
//     success: function (response) {
//       $('body .pdp-qty').each(function () {
//         const $element = $(this);
//         const productId = $element.attr('data-product-id');
//         const cartItem = response.items.find(item => item.id == productId);
//         const quantity = cartItem ? cartItem.quantity : 0;
//         $element.attr('data-cart-quantity', quantity);
//         $element.closest('quantity-selector').find('.pdp_quantity__input').attr('data-cart-quantity', quantity);
//       });
//       const cartIcon = document.querySelector('.cart-drawer-button .cart-count');
//         if (cartIcon) {
//           cartIcon.innerText = response.item_count;
//           cartIcon.removeAttribute('hidden');
//         }
//     },
//     error: function (err) {
//       console.error('Error fetching cart data:', err);
//     }
//   });
// },800);
// }
if (document.referrer.includes("collections")) {
  $.ajax({
  type: 'GET',
  url: '/cart.js',
  dataType: 'json',
  success: function (response) {
    $('body .pdp-qty').each(function () {
      const $element = $(this);
      const productId = $element.attr('data-product-id');
      const cartItem = response.items.find(item => item.id == productId);
      const quantity = cartItem ? cartItem.quantity : 0;
      $element.attr('data-cart-quantity', quantity);
      $element.closest('quantity-selector').find('.pdp_quantity__input').attr('data-cart-quantity', quantity);
    });
    const cartIcon = document.querySelector('.cart-drawer-button .cart-count');
      if (cartIcon) {
        cartIcon.innerText = response.item_count;
        cartIcon.removeAttribute('hidden');
      }
  },
  error: function (err) {
    console.error('Error fetching cart data:', err);
  }
});
  console.log("zydus collection true " , true );
}
jQuery(document).ready(function () {
  const form_product_id = $("#form_product_id").val();
  $('.sticky-btn').on('click', function () {
    $('.main-btn').trigger('click');
  });
  var bummer_product_handles = [];
  // Populate bummer_product_handles array with product handles
  jQuery('.custom_link').each(function () {
    var productHandle = jQuery(this).data('url');
    bummer_product_handles.push(productHandle);
  });
  if (!jQuery('.group-label.active').length) {
    jQuery('.group-label').first().addClass('active');
  }
  if (!jQuery('.related_group_products.active').length) {
    jQuery('.related_group_products').first().addClass('active').css('display', 'flex');
  }
  if (!jQuery('.related_group_products.active .custom_link').hasClass('activeData')) {
    jQuery(jQuery('.related_group_products.active .custom_link').first()).addClass('activeData');
  }
  var initialProductHandle = jQuery('.related_group_products.active .activeData').data('url');
  if (initialProductHandle) {
    getProductDetails(initialProductHandle);
  }
  jQuery(document).on('click', '.custom_link', function (e) {
    e.preventDefault();
    var group = jQuery(this).closest('.related_group_products'); // Current group of related products
    if (jQuery(this).hasClass('activeData')) {
      return;
    }
    group.find('.custom_link').removeClass('activeData'); // Only within this group
    jQuery(this).addClass('activeData');
    var selectedProductHandle = jQuery(this).data('url');
        var sectionId = $("#form_product_id").data('section-id');
        var productData = {
            variantId: jQuery(this).data('variant-id'),
            productId: jQuery(this).data('product-id')
        };
        // Log data for debugging
        console.log("Selected Product Handle:", selectedProductHandle);
        console.log("Section ID:", sectionId);
        console.log("Product Data:", productData);
        // Validate form and dynamically update fields
        var form = $(".product-forms, .quantity-form");
        if (form.length) {
            // Check if productData has valid values before updating
            if (productData.variantId && productData.productId) {
                form.find("[name=id]").val(productData.variantId).trigger('change');
                form.find("[name=product-id]").val(productData.productId).trigger('change');
                console.log("Form updated with Variant ID and Product ID");
            } else {
                console.error("Invalid product data:", productData);
            }
        } else {
            console.error("Form not found for Section ID:", sectionId);
        }
      document.querySelector('body').classList.add('Webloading');
      $('.websiteLoader').show();
      
        setTimeout(() => {
        document.querySelector('body').classList.remove('Webloading');
        $('.websiteLoader').hide();
        }, 1000);
    getProductDetails(selectedProductHandle);
    updateProductHandleInURL(selectedProductHandle);
  });
  function getProductDetails(productHandle) {
    const websiteUrl = `${location.protocol}//${location.host}`;
    const fullUrl = `${websiteUrl}/${productHandle}.js`;
    $.ajax({
      url: fullUrl,
      method: 'GET',
      contentType: 'application/json',
      dataType: 'json', // Expect JSON response
      success: function (data) {
        console.log("Full URL data:", data);
        // Extract and update main product details
        const productTitle = data.title;
        const product_id = data.id;
        const first_variant = data.variants[0].id;
        const product_image = data.media;
        const sku = first_variant.sku;
        const available = data.variants[0].available;
        const variantPrice = first_variant.price;
        const inventoryQuantity = first_variant.inventory_quantity;
        const tags = data.tags;
        console.log("Inventory Quantity:", inventoryQuantity);
        console.log("available:", available);
        console.log("product_id:", product_id);
        section_id = $("#form_product_id").attr("data-section-id");
        console.log("product_image:", product_image);
        // Update HTML elements
        $('.product__title').text(productTitle);
        $('.breadcrumbs--last').text(productTitle);
        // Additional data updates
        fetchAdditionalData(data.handle);
        let offerLabel = '';
        tags.forEach(tag => {
          if (tag === 'pfs:label-Buy 1 Get 1 Free') {
            offerLabel = 'Buy 1 Get 1 Free';
          }
          else if (tag === 'pfs:label-Buy 2 Get 1 Free') {
          offerLabel = 'Buy 2 Get 1 Free';
          }
        });
        if (offerLabel) {
          console.log('Offer:', offerLabel);
          $('.pdp-offer-tag').text(offerLabel);
          $('.pdp-offer-tag').show();
        }
        else{
          $('.pdp-offer-tag').text();
          $('.pdp-offer-tag').hide();
        }
        product_image.forEach((mediaItem) => {
            const mediaSrc = mediaItem.src;
            const mediaID = mediaItem.id;
            const mediaIndex = mediaItem.position - 1; // Assuming position starts at 1, but index starts at 0
          
            // Select the slide by data-media-index
            const slide = $(`.product__media-item.swiper-slide[data-media-index="${mediaIndex}"]`);
            const zoomI = slide.find('.product__media');
            const zoomIs = slide.find('.product__media-zoom');
          
            // Update attributes
            slide.attr("data-src", mediaSrc);
            slide.find("img").attr("src", mediaSrc);
            slide.find("img").attr("srcset", mediaSrc);
            slide.attr("data-media-id", mediaID);
            zoomI.attr("data-media-id", mediaID);
            zoomIs.attr("data-media-id", mediaID);
          });
        const mediaGallery = document.querySelector('media-gallery');

          if (mediaGallery && typeof mediaGallery.initImageZoom === 'function') {
          if (mediaGallery.lightbox && typeof mediaGallery.lightbox.destroy === 'function') {
          mediaGallery.lightbox.destroy();
          mediaGallery.lightbox = null;
          }
          mediaGallery.initImageZoom();
          }
        const cartQty =  parseInt($('body .pdp-qty').data('cart-quantity'));
        const maxMetaQty = parseInt($('body .pdp-qty').attr('max'));
        if(available == true && maxMetaQty != cartQty ){
          $('body .sticky-btn').attr("disabled", false);
          $('body .sticky-btn').html("<span>Add to Cart</span>");    
          $("body #"+form_product_id).find("button[name=add]").attr("disabled", false);
          $("body .shopify-payment-button__button").attr("disabled", false);
          $("body #"+form_product_id).find("button[name=add]").html('<span>Add to Cart</span>').append(`
          <div class="loading__spinner hidden">
            <svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        `);
         
      }else{
          $('.quantity__input[name="quantity"]').val(0);
          $('body .sticky-btn').attr("disabled", true);
          $('body .sticky-btn').html("<span>Sold Out</span>");
          $("body #"+form_product_id).find("button[name=add]").attr("disabled", true);
          $("body #"+form_product_id).find("button[name=add]").html("<span>Sold Out</span>");
          $("body .shopify-payment-button__button").attr("disabled", true);
      }
        console.log("maxMetaQty" + maxMetaQty);
        const firstVariantId = data.variants[0].id;
        const skus = data.variants[0].sku;
                const productId = data.id;
                const sectionId = $("#form_product_id").data('section-id');
                var form = $(".product-forms, .quantity-form");
                if (form.length) {
                    form.find("[name=id]").val(firstVariantId).trigger('change');
                    form.find("[name=product-id]").val(productId).trigger('change');
                    form.find("[name=sku]").val(skus).trigger('change');
                    console.log("Form updated with fetched product data");
                }
        $("#mswishlistbutton").attr("data-product-name", productTitle);
        $("#mswishlistbutton").attr("data-variant", firstVariantId);
        $("#mswishlistbutton").attr("data-product", productId);
        $("#mswishlistbutton").attr("data-unique-id", productId);
        $("#judgeme_product_reviews").attr("data-product-title", productTitle);
        $("#judgeme_product_reviews").attr("data-id", productId);
        
        $("body .product__sharing--inputs").find("[name=id]").val(websiteUrl + productHandle+'?variant='+first_variant).trigger('change');
        console.log(websiteUrl + productHandle+'?variant='+first_variant);
        window.history.replaceState({}, "", websiteUrl + productHandle+'?variant='+first_variant);
        $(".quantity").attr("data-url", productHandle);
        
        $("[id=url]").val(websiteUrl + productHandle+'?variant='+first_variant);
      },
      error: function (xhr, status, error) {
        console.error("Error fetching full URL data:", status, error);
      }
    });
  }
  function fetchAdditionalData(productHandle) {
    const additionalUrl = `/products/${productHandle}?view=ajax_scented_data`;
    $.get(additionalUrl, function (data) {
      const $parsedData = $(data);
      const price = $parsedData.find('#product_price').html();
      const productDescription = $parsedData.find('#product__description').html();
      const productImages = $parsedData.find('#main-img').html();
      const weightProducts = $parsedData.find('#family_group_size').html();
      const variantProducts = $parsedData.find('#family_group_size1').html();
      const rifilProducts = $parsedData.find('#family_group_size2').html();
      const metaImages = $parsedData.find('#image-banner-products').html();
      const sliderImages = $parsedData.find('#product-img-slider').html();
      const overviewData = $parsedData.find('#overview').html();
      const nutritional_info = $parsedData.find('#nutritional_info').html();
      const ingredients = $parsedData.find('#ingredients').html();
      const product_specification = $parsedData.find('#product_specification').html();
      const additional_details = $parsedData.find('#additional_details').html();
      const image_with_text = $parsedData.find('#image_with_text').html();
      const faqs = $parsedData.find('#faqs').html();
      const faqsData = $parsedData.find('#faqs .custom_faq-data').html();
      const wishData = $parsedData.find('#wish-update').html();
      const upQty = $parsedData.find('.update-qty').html();
      var minMetaQty = parseInt($('body .pdp-qty').attr('data-meta_min_qty_limit')) ;
      var minAvlQty = parseInt($('body .pdp-qty').attr('data-min')) ;
      const maxMetaQty = parseInt($('body .pdp-qty').attr('data-meta_max_qty_limit'));
      const maxQty =  parseInt($('body .pdp-qty').attr('max'));
      const cartQty =  parseInt($('body .pdp-qty').data('cart-quantity'));
      const cartSku = $parsedData.find('body .pdp-qty').data('sku');
      console.log('faqsData', maxQty);
      
      // minimum qunaity limit updated
      if(minMetaQty){
        $(".pdp_quantity__input[name='quantity']").attr('data-meta_min_qty_limit', minMetaQty);
        $(".pdp_quantity__input[name='quantity']").attr('data-min', minMetaQty);
        $(".quantity__input[name='quantity']").attr('min', minMetaQty);
        if(cartQty < minMetaQty ){
          minMetaQty = minMetaQty - cartQty;
           $(".quantity__input[name='quantity']").attr('value', minMetaQty);
        }
      }
      // maximum qunatity limit updated
      if(maxMetaQty){
          $(".pdp_quantity__input[name='quantity']").attr('data-meta_max_qty_limit', maxMetaQty);
          if(maxMetaQty > maxQty) { 
            $(".quantity__input[name='quantity']").attr('max', maxQty);
          }
          else{ 
            $(".quantity__input[name='quantity']").attr('max', maxMetaQty);
          }
      }
      // maximim quanity avialble in inventory 
       if (maxQty) {
          $(".product-quantity[name='qty']").val(maxQty);
          $(".pdp_quantity__input[name='quantity']").attr('data-available-qty', maxQty);
          $(".quantity__input[name='quantity']").attr('max', maxQty);
      }
      // cart quantity
      if (cartQty) {
        $(".data-available-qty[name='quantity']").attr('data-cart-quantity', cartQty);
        $(".pdp-qty").attr('data-cart-quantity', cartQty);
      }
      
      if (cartSku) {
       $(".quantity__input[name='quantity']").attr('data-sku', cartSku);
        $(".pdp-qty").attr('data-sku', cartSku);
      }
      // Update HTML containers
      if (upQty) {
        $(".main-qtyy").html(upQty);
      }
      if (price) {
        $(".price-boxx").html(price);
      }
      if (productImages) {
        $(".product__media-wrapper").html(productImages);
      }
      if (productDescription) {
        $(".product__description").html(productDescription);
      }
      if (weightProducts) {
        $(".custom_weight_container").html(weightProducts);
      }
      if (variantProducts) {
        $(".custom_flavour_container").html(variantProducts);
      }
      if (rifilProducts) {
        $(".custom_packaging_container").html(rifilProducts);
      }
      if (metaImages) {
        //$(".new-products-img").html(metaImages);
        $(".product--image--banner").html(metaImages);
      }
      if (sliderImages) {
        $(".image_slider_section").html(sliderImages);
      }
      if (overviewData) {
        $(".product__block--overview").html(overviewData);
      }
      if (nutritional_info) {
        $(".product__block--nutritional-info").html(nutritional_info);
      }
      if (ingredients) {
        $(".product__block--ingredients p").html(ingredients);
      }
      if (product_specification) {
        $(".product__block--product-specification").html(product_specification);
      }
      if (additional_details) {
        $(".product__block--additional-details").html(additional_details);
      }
      if (image_with_text) {
        $(".image_with_text-wraper").html(image_with_text);
      }
      if (wishData) {
        $(".wishlist_container").html(wishData);
      }
      if (faqsData == "") {
        $(".custom_faq").addClass("hidden");
      }else{
        $(".custom_faq").removeClass("hidden");
        $(".custom_faq").html(faqs);
      }
      setTimeout(function() {
        initializeMaxbuy();  
      }, 1000); 
      // Trigger a stored family group button click
      const familyName = localStorage.getItem("familyName");
      if (familyName) {
        $(`div.family_group_list button[data-familyname="${familyName}"]`).trigger("click");
      }
    }).fail(function () {
      console.error("Failed to fetch additional data.");
    });
  }
  // Function to update the product handle in the URL
  function updateProductHandleInURL(productHandle) {
    var newUrl = `${window.location.origin}${productHandle}`;
    history.pushState({ path: newUrl }, '', newUrl);
  }
 
  function initializeMaxbuy() {
    var sku =  $('body .pdp-qty').attr('data-sku');
    var dataProductId = $('body .pdp-qty').attr('data-product-id');
    var availableQty = $('body .pdp-qty').attr('data-available-qty');
    var minAvlQty = parseInt($('body .pdp-qty').attr('min')) ;
    var minPurchaseLimit = parseInt($('body .pdp-qty').attr('data-meta_min_qty_limit')); 
    var maxPuchaseLimit = parseInt($('body .pdp-qty').attr('data-meta_max_qty_limit')) ;
    var effectiveMax = Math.min(maxPuchaseLimit, availableQty);
    var quantityInCart = parseInt($('body .pdp-qty').attr('data-cart-quantity'));
    var newCartQuantity = quantityInCart; 
    var newMaxAvlQuantity = Math.min(maxPuchaseLimit - newCartQuantity, availableQty - newCartQuantity);
    console.log(maxPuchaseLimit + ' maxPuchaseLimit ' + availableQty + ' availableQty '   + effectiveMax + ' effectiveMax '+ quantityInCart + ' quantityInCart ' + newMaxAvlQuantity + " newMaxAvlQuantity");
    //input attributes updated
    $('.quantity__input[name="quantity"]').attr('data-sku', sku);
    $('.quantity__input[name="quantity"]').attr('data-cart-quantity', quantityInCart);
    $('.quantity__input[name="quantity"]').attr('data-available-qty', availableQty);
    $('.quantity__input[name="quantity"]').attr('min', minAvlQty);
    $('.quantity__input[name="quantity"]').attr('value', minAvlQty);
    $('.quantity__input[name="quantity"]').attr('data-meta_min_qty_limit', minPurchaseLimit);
    $('.quantity__input[name="quantity"]').attr('data-meta_max_qty_limit', maxPuchaseLimit);
    $('.quantity__input[name="quantity"]').attr('max', newMaxAvlQuantity);
    $('.quantity__input[name="quantity"]').attr('data-product-id', dataProductId);
    //class pdp-qty div attributes updated
    $('body .pdp-qty').attr('data-sku', sku);
    $('body .pdp-qty').attr('data-cart-quantity', quantityInCart);
    $('body .pdp-qty').attr('data-available-qty', availableQty);
    $('body .pdp-qty').attr('min', minAvlQty);
    $('body .pdp-qty').attr('data-meta_min_qty_limit', minPurchaseLimit);
    $('body .pdp-qty').attr('data-meta_max_qty_limit', maxPuchaseLimit);
    $('body .pdp-qty').attr('max', newMaxAvlQuantity);
    if (newMaxAvlQuantity <= 0 || quantityInCart == effectiveMax ) {
      $("body #"+form_product_id).find("button[name=add]").attr('disabled', true);
      $('body .sticky-btn').attr("disabled", true);
      $('body .sticky-btn').html("<span>Sold Out</span>");
      $("body #"+form_product_id).find("button[name=add]").html("<span>Sold Out</span>");
      $('.quantity__input[name="quantity"]').attr('min', 0);
      $('body .pdp-qty').attr('min',0);
      $('.quantity__input[name="quantity"]').attr('data-min', 0);
      $('body .pdp-qty').attr('data-min',0);
      $('.quantity__input[name="quantity"]').val(0);
        if(availableQty < maxPuchaseLimit){
         $('.item-added-cart').text("The requested quantity for this product is not available and can't be added to your cart."); 
        }
        else{
          $('.item-added-cart').text('The maximum allowed purchase quantity for this product is ' + effectiveMax);
        }
      return false;
     }
    else if ((minPurchaseLimit == minAvlQty ) && (minPurchaseLimit > newMaxAvlQuantity )){
      $('.quantity__input[name="quantity"]').attr('min', 0);
      $('body .pdp-qty').attr('min',0);
      $('.quantity__input[name="quantity"]').attr('max', 0);
      $('body .pdp-qty').attr('max',0);
      $('.quantity__input[name="quantity"]').attr('data-min', 0);
      $('body .pdp-qty').attr('data-min',0);
      $('.quantity__input[name="quantity"]').val(0);
      $("body #"+form_product_id).find("button[name=add]").attr("disabled", true);
      $("body #"+form_product_id).find("button[name=add]").html("<span>Sold Out</span>");
      $('body .sticky-btn').attr("disabled", true);
      $('body .sticky-btn').html("<span>Sold Out</span>");
      $("body .shopify-payment-button__button").attr("disabled", true);
     }
    else{
      if(minAvlQty <= 1 ){
        $('.minpurchaseMsg').hide();
      }
      else{
        $('.minpurchaseMsg').show();
        $('.minpurchaseMsg').text(`The minimum purchase quantity for this product is ${minPurchaseLimit}`);
      }
      $('.pdp_quantity__input[name="quantity"]').attr('min', minAvlQty);
      $('.pdp_quantity__input[name="quantity"]').val(minAvlQty);
      $("body #"+form_product_id).find("button[name=add]").attr("disabled", false);
      $("body #"+form_product_id).find("button[name=add]").html("<span>ADD TO CART</span>").append(`
          <div class="loading__spinner hidden">
            <svg aria-hidden="true" focusable="false" class="spinner icon icon--extra-medium" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
              <circle class="path" fill="none" stroke-width="4" cx="33" cy="33" r="30"></circle>
            </svg>
          </div>
        `);
      return true;
    }
  }
  const productGroup = document.querySelector('.product__block--product_group');
  if (productGroup) {
    const hasDynamicElements = productGroup.querySelector('.customProductGroup'); 
    if (!hasDynamicElements) {
      setTimeout(function () {
      initializeMaxbuy();
      }, 1000);
      // setInterval(() => { initializeMaxbuy();},1000);
    }
  }

});

